<template>
    <div class="inner-box">
      <div slot="content">
        <el-form size="medium" @submit.prevent="save">
          <div class="content-name">
            <h2 class="dp-ib">{{ routeName }}</h2>
            <el-form-item label-width="0px" style="float: right;">
              <el-button type="primary" icon="el-icon-search" @click="goOpen">
                {{ this.$i18n.messages[this.$store.state.locale].search }}
              </el-button>
              <el-button type="success" icon="el-icon-check" @click="inSave">
                도착확인
              </el-button>
            </el-form-item>
          </div>
        </el-form>
  
        <div class="search-form">
          <el-form size="mini">
            <el-row style="margin-bottom: 0px;">
              <el-col :span="12">
                <el-form-item label="요청일자" label-width="100px">
                  <el-row>
                    <el-col>
                      <el-col :span="11">
                        <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: center;">-</el-col>
                      <el-col :span="12">
                        <el-date-picker type="date" placeholder="종료" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="요청기사" label-width="100px">
                  <el-select v-model="form.userId" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['userId']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="요청구분" label-width="100px">
                    <el-select v-model="form.outType" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['outType']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="제조사" label-width="100px">
                    <el-select v-model="form.maker" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['Maker']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="제품군" label-width="100px">
                    <el-select v-model="form.itemGroup" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['ModelGroup']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="품번" label-width="100px">
                  <el-input type="text" v-model="form.itemCd"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="data"
                  :context="context"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :statusBar="statusBar"
                  :stopEditingWhenCellsLoseFocus="true"
                  @grid-ready="onReadyMain" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
  import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
  import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
  import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
  import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
  import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
  import InputCellRender from "@/components/agGrid/input-cell-renderer";
  import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
  import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";
  
  function _url(...args) {
    args = args.map(x =>
        String(x || "")
            .trim()
            .replace(/^\/*|\/*$/g, "")
    );
    return args.filter(x => x).join("/");
  }
  
  export default {
    props: {
    },
    data() {
      return {
        data: [],
        parentId: "0",
        form: {
          companyId : '',
          startDt: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
          endDt: this.$moment().format('YYYY-MM-DD'),
          catId: 0,
          asAgentId: 0,
          userId: '',
          maker: '',
          itemGroup: '',
          itemCd: '',
          outType: '',
          procYn: '',
          sortType : '',           // 승인/정산처리유형
          page : 1,
          totalpage : 9999,
          curPage : 1,
          totalCount : 9999,
          processTime : ''
        },
        combos: {
          'Maker': [], //제조사
          'ModelGroup': [], //제품군
          'ModelDetail': [], //제품군 select,
          'userId': [] // 요청기사
        },
        gridStyle : 'padding-top: 40px; width: 100%;height: 700px; min-height:100px;',
        defaultColDef: {
            resizable: true
          , filter:false
          , sortable: true
        },
        mainGridApi: null,
        mainColumnApi: null,
        mainGridOptions: {
          enableColResize: true,
          enableFilter: true,
          animateRows: false,
          enableSorting: true,
        },
        context: {
          //checkbox 전체 체크 이벤트 추가
          headerAllCheckEvent: this.allCheckEvnet
        },
        columnDefs: [],
        frameworkComponent : {
          datePicker: DatepickerCellRenderer,
          maskEdit: MaskEditCellRenderer,
          select: SelectCellRenderer,
          checkBox: CheckboxCellRenderer,
          radio: RadioCellRenderer,
          numberInput: NumberInputCellRender,
          input: InputCellRender,
          button: ButtonCellRenderer
        },
        statusBar: null,
      }
    },
    methods: {
      async onReadyMain() {
        this.mainGridApi = this.mainGridOptions.api;
        this.mainColumnApi = this.mainGridOptions.columnApi;
  
        await this.init().finally( _ => {
          setTimeout(async () => {
            await this.goOpen();
          },1500);
          
        })
      },
      createMainColumnDefs() {
        const vm = this;

        this.columnDefs = [
          {
              field:'chk',
              width:80,
              headerComponent: `checkBox`,
              headerComponentParams: (params) => {
                  return params;
              },
              cellStyle : {textAlign: 'center'},
              cellRenderer: 'checkBox',
              cellRendererParams: (params) => {
                  return {
                      trueValue: 'Y',
                      falseValue: 'N',
                      disable: params.data.inDt === null ? false : true
                  }
              }
          },
          {headerName:'itemId', field: 'itemId', hide: true},
          {headerName:'요청일시', field:'createDt', width:180, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateTimeFormat(`${params.value}`)
            }},
          {headerName:'요청구분', field:'outType', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'요청기사', field:'requestUserNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'사이트', field:'requestCustNm', width:250, cellStyle:{textAlign: 'center'}},
          {headerName:'제조사', field:'makerNm', width:120, cellStyle:{textAlign: 'center'}},
          {headerName:'제품군', field:'itemNm', cellStyle:{textAlign: 'center'}, width:160},
          {headerName:'품번', field:'itemCd', width:160, cellStyle:{textAlign: 'center'} },
          {headerName:'요청수량', field:'inGoodQty', width:110, cellStyle:{textAlign: 'right'}},
          {headerName:'출고센터', field:'outAsAgentNm', width:110, cellStyle: {textAlign: 'center'}},
          {headerName:'출고일자', field:'outDt', width:110, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateFormat(`${params.value}`)
            }},
          {headerName:'입고일자', field:'inDt', width:110, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateFormat(`${params.value}`)
            }},
          {headerName:'입고수량', field:'inGoodQty', width:110, cellStyle:{textAlign: 'right'}},
          {headerName:'메모', field:'memo', width:180, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return params.value;
            }
          }
        ];
      },
      /**
       * grid 내에 체크박스 전체 체크 함수
       * @param {*} field 
       * @param {*} checked 
      */
      allCheckEvnet(field, checked) {
        return this.data = this.data.map(x => {
            if(!x.inDt) {
                x[field] = checked ? 'Y' : 'N';
            }
            return x;
        })
      },
      getDateFormat(val) {
        if (val) {
          return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
        }
      },
      getDateTimeFormat(val) {
        if (val) {
          return val === 'null' ? '' : this.$moment(val).format('yyyy-MM-DD HH:mm:ss')
        }
      },
      async goOpen() {
          this.$store.commit('loading')
          await this.$http.post(_url("/api/agent/mateEnterList/list"), this.form).then(async response => {
            this.data = await this.changeData(response.data);
          }).finally(async _ => {
            this.$store.commit('finish')
          });
      },
      changeData(data) {
        return data.map((x, i) => {
           if (x.outType == "Agent") { x.outType = '' }
           else {
             let filterOutType = this.combos['outType'].filter(y => y.key === x.outType);
             x.outType = filterOutType[0]?.value;
           }
           return x;
         })
      },
      save() {
        console.log('test',this.$parent.$refs.step.next())
      },
      /**
       * 접수/처리 상세 팝업 오픈
       */
      openModel(param) {
        console.log(param);
        let vm = this;
        this.$modal.open({
          width: 800,
          component: ReceptionModal_01,
          parent: this,
          props: {
            data: {
              asId: param.asId,
              custId: param.custId,
              sortType: '',
              popHeadInfo: '', //this.custParam.popHeadInfo,
              //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
              recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
              procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
            }
          },
          events: {
            close(data) {
              console.log('close', data);
            },
          }
        });
      },
      $dismiss() {
        this.$emit('dismiss')
        this.$parent.close()
      },
      inSave() {
        var list = this.data.filter(y =>  y.chk === 'Y')

        if (list.length > 0) {
          let result = [];
          let saveForm = {};

          list.forEach(x => {
             saveForm = {
                productType: 'Item',
                outItemId: x.outItemId,
                updatorId: this.$store.state.loginInfo.id
              }
              result.push(saveForm);
          })
          this.$swal({
            type: 'warning',
            text: '도착확인을 하시겠습니까?',
            showCancelButton: true,
            confirmButtonText: '예',
            cancelButtonText: '아니요',
          }).then((res) => {
            if (res.value) {
              this.$store.commit('loading')
              this.$http.post(("/api/agent/mateEnterList/save"), result).then(r => {
                this.$swal({type: 'success', text: '도착확인을 완료했습니다.'})
                    .then(res => {
                      if (res) {
                        this.goOpen();
                      }
                    })
              }).catch((e) => {
                this.$swal({type: 'warning', text: '도착확인에 실패 했습니다.'})
              }).finally(() => {
                this.$store.commit('finish')
              });
            }
          })
        }
        else {
          this.$swal({
            type: 'warning',
            text: '자재를 선택해 주십시요.'
          });
        }
      },
      async init() {
        // this.$store.commit('loading');

        let [ agent, init ] = await Promise.all([this.$http.post("/api/asAgentMng/detail/agent", {
          companyId: this.$store.state.loginInfo.compCd,
          asAgentId: this.form.asAgentId,
          userId : 0,
          useYn : 'Y',
          processTime: ""
          }), this.$http.post(`/api/agent/mateEnterList/init`)])

        if(agent) {
          agent.data.map(x => {
            x.key = x.userId
            x.value = x.userNm
            return x;
          });
          this.combos['userId'] = agent.data;
        }

        const  {itemGroup, maker, requestType} = init.data;

        this.combos['outType'] = requestType; //입고구분
        this.combos['Maker'] = maker;
        this.combos['ModelGroup'] = itemGroup;
        // this.$store.commit('finish');
        this.createMainColumnDefs();
      },
    },
    created() {
      this.statusBar = {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
      };
    },
    mounted() {
      this.form.companyId = this.$store.state.loginInfo.compCd;
      this.form.requestUserNm = this.$store.state.loginInfo.userName;
      this.form.asAgentId = this.$store.state.loginInfo.asAgentId;
    },
    computed: {
      routeName() {
        return this.$route.name
      }
    },
  }
  </script>
  
  
  <style lang="scss" scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  </style>